import type { FC } from "react";

import { BookmarkIconAsButton } from "components";
import { TopicAssignmentsNavigation } from "features";
import { BlacklistIconAsButton } from "features/Blacklist/BlacklistToggleButton";
import { AssignmentHistoryButton } from "components/Buttons/AssignmentHistory";

interface Props {
  assignmentId: string;
  userAssignmentId: string;
  themeId: string;
  onNavigate: (assignmentId: string) => void;
  title: string;
}

export const TopicAssignmentDetailHeader: FC<Props> = ({
  assignmentId,
  themeId,
  title,
  userAssignmentId,
  onNavigate,
}) => (
  <div className="assignment-detail-header">
    <div className="assignment-detail-header__title">
      <h2 className="mb-0">{title}</h2>
    </div>
    <div className=" me-4px pe-2">
      <AssignmentHistoryButton userAssignmentId={userAssignmentId} assignmentId={assignmentId} />
    </div>
    <div className="border-start border-1 assignment-navigation px-2">
      <BlacklistIconAsButton className="ms-4px" userAssignmentId={userAssignmentId} />
      <BookmarkIconAsButton className="ms-4px" userAssignmentId={userAssignmentId} />
    </div>
    <div className="border-start border-1 ps-2">
      <TopicAssignmentsNavigation userAssignmentId={userAssignmentId} themeId={themeId} onNavigate={onNavigate} />
    </div>
  </div>
);
